import { dataCalculator } from "../../modules/form/setValueForm";
class CalculatorService {
    // nameForm: string = '';
    constructor(formState) {
        this.formState = formState;
        // this.nameForm = this.formState.manageState('idForm');
    }
    sendLead(formData) {
        fetch('/api/v1/calculator', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }).then(response => response.json())
            .then(response => {
            window.sessionStorage.setItem('sidCalculator', response['ID_registro']);
            dataCalculator.sendUserDataToAVI(formData, response['ID_registro']);
            if (response['estado'] == "nuevo" || response["ID_registro"] != '') {
            }
        });
    }
}
export { CalculatorService };
